import React from 'react';
import { Settings, ChevronDown, X } from 'lucide-react';
import { ColumnOption } from '../types';

interface ColumnSettingsProps {
  columnOptions: ColumnOption[];
  visibleColumns: Record<string, boolean>;
  showColumnSettings: boolean;
  setShowColumnSettings: (show: boolean) => void;
  toggleColumn: (key: string) => void;
  resetColumnsToDefault: () => void;
}

const ColumnSettings: React.FC<ColumnSettingsProps> = ({
  columnOptions,
  visibleColumns,
  showColumnSettings,
  setShowColumnSettings,
  toggleColumn,
  resetColumnsToDefault,
}) => {
  return (
    <div className="relative">
      <button
        onClick={() => setShowColumnSettings(!showColumnSettings)}
        className="flex items-center space-x-1 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white text-sm rounded px-2 py-1 bg-gray-100 dark:bg-gray-700"
        aria-expanded={showColumnSettings}
        aria-haspopup="true"
      >
        <Settings size={16} />
        <span>Columns</span>
        <ChevronDown
          size={16}
          className={`transition-transform ${showColumnSettings ? 'rotate-180' : ''}`}
        />
      </button>

      {showColumnSettings && (
        <div className="absolute right-0 mt-2 w-64 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
          <div className="p-3 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
            <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">Table Columns</h3>
            <button
              onClick={() => setShowColumnSettings(false)}
              className="text-gray-400 hover:text-gray-500"
            >
              <X size={16} />
            </button>
          </div>
          <div className="py-1 max-h-64 overflow-y-auto">
            {columnOptions.map((col) => (
              <div key={col.key} className="px-3 py-2 flex items-center">
                <input
                  type="checkbox"
                  id={`col-${col.key}`}
                  checked={visibleColumns[col.key] || false}
                  onChange={() => toggleColumn(col.key)}
                  className="h-4 w-4 text-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)] border-gray-300 rounded"
                />
                <label
                  htmlFor={`col-${col.key}`}
                  className="ml-2 block text-sm text-gray-700 dark:text-gray-300"
                >
                  {col.label}
                </label>
              </div>
            ))}
          </div>
          <div className="p-3 border-t border-gray-200 dark:border-gray-700 flex justify-end">
            <button
              onClick={resetColumnsToDefault}
              className="text-xs text-[rgb(227,66,144)] hover:text-[rgb(227,66,144)]/80 dark:text-[rgb(227,66,144)] dark:hover:text-[rgb(227,66,144)]/80"
            >
              Reset to defaults
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnSettings;
